"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIDDEN_DIRECTORIES = void 0;
exports.HIDDEN_DIRECTORIES = ['.codesandbox'];
